////////////// JQUERY CONFLICT NO PLEASE

(function ($) {


    ///////////////////////////////////
    ///////     FUNCTIONS     /////////
    ///////////////////////////////////


    // var mincheckout, checkin_date, checkout_date, checkin_dp = $('#bookingform-check #checkin-check'), checkout_dp = $('#bookingform-check #checkout-check');
    // $('#bookingform-check').accorBookingInitDatepickers(
    //     {
    //         onSelect: function ( dateText, inst ) {
    //             $('#bookingform-check label[for="checkin-check"] > span').text(dateText);
    //             checkin_date = checkin_dp.datepicker('getDate');
    //             checkout_date = checkout_dp.datepicker('getDate');
    //             if (checkout_date <= checkin_date) {
    //                 mincheckout = new Date(checkin_date.getTime()+86400000);
    //                 checkout_dp.datepicker('option', 'minDate', mincheckout);
    //                 checkout_dp.datepicker('setDate', mincheckout);
    //                 var _month = mincheckout.getMonth()+1;
    //                 $('#bookingform-check label[for="checkout-check"] > span').text(mincheckout.getDate()+'/'+(_month < 10 ? '0'+_month : _month)+'/'+mincheckout.getFullYear());
    //             }
    //             checkin_dp.trigger('change');
    //             checkout_dp.trigger('change');
    //         }
    //     },
    //     {
    //         onSelect: function ( dateText, inst ) {
    //             $('#bookingform-check label[for="checkout-check"] > span').text(dateText);
    //             checkin_date = checkin_dp.datepicker('getDate');
    //             checkout_date = checkout_dp.datepicker('getDate');
    //             if (checkin_date >= checkout_date) {
    //                 maxcheckin = new Date(checkout_date.getTime()-86400000);
    //                 checkin_dp.datepicker('option', 'minDate', maxcheckin);
    //                 checkin_dp.datepicker('setDate', maxcheckin);
    //                 var _month = maxcheckin.getMonth()+1;
    //                 $('#bookingform-check label[for="checkin-check"] > span').text(maxcheckin.getDate()+'/'+(_month < 10 ? '0'+_month : _month)+'/'+maxcheckin.getFullYear());
    //             }
    //             checkin_dp.trigger('change');
    //             checkout_dp.trigger('change');
    //         }
    //     }
    // );

    ///////////////////////
    // BOOKING
    ///////////////////////

    // open close booking form
    window.hotel_bookingform = window.hotel_bookingform || function(){
        // vars
        var btns = jQuery('.hotel_bf');
        var	btn_close = $('#close_booking');
        var booking_form_wrap = $('#booking_form_wrap');
        var bookingform = $('#bookingform');
        var	mClass = ('opened');
        var noScrollClass = ('noscroll');
        // check
        if (btns.length === 0 || booking_form_wrap.length === 0 ) return false;
        // click fancy
        btns.each(function(){
            // this
            var btn = $(this);
            // bind fancy
            btn.on('click',function(){
                // action
                if (!booking_form_wrap.hasClass(mClass)) {
                    // open
                    $('html').addClass(noScrollClass);
                    booking_form_wrap.addClass(mClass);
                }

                //
                bookingform.accorBookingInitSingleDatepicker({
                    checkinDateSelector: '.checkin',
                    checkoutDateSelector: '.checkout',
                    dateFormat: 'dd MM yy',
                    inlineDpArgs: {

                    }
                });
                bookingform.accorBookingForm({altSubmitAction : function(formParameters) {
                        (function (params) {
                            $('#booking_popup').show();
                            $('.booking_popup-button').click(function () {
                                console.log('booking params',params);
                                accorBookNow(params);
                                return false;
                            });
                        })(formParameters);
                    }}); 
                /*else {
                    if(booking_form_wrap.hasClass(mClass)){
                        // close
                        $('html').removeClass(noScrollClass);
                        booking_form_wrap.removeClass(mClass);
                    }
                }*/
            });
        });

        // close part
        // btn
        btn_close.on('click',function () {
            if(booking_form_wrap.hasClass(mClass)){
                // close
                $('html').removeClass(noScrollClass);
                booking_form_wrap.removeClass(mClass);
            }
        });
        // document
        $(document).on('click',function (event) {
            if (  !$(event.target).closest('#booking_form_box').length
                && !$(event.target).closest('.ui-datepicker-group').length
                && !$(event.target).closest('#hotel_menu').length
            // && !$(event.target).closest('.map_marker_popup').length
            // && !$(event.target).closest('#customizations_list .offer').length
            ) {
                if(booking_form_wrap.hasClass(mClass)){
                    // close
                    $('html').removeClass(noScrollClass);
                    booking_form_wrap.removeClass(mClass);
                }
            }
        });
    };


    // book now button for hotel
    window.hotel_book_now = window.hotel_book_now || function(){
        //
        var btns = jQuery('.hotel_book');
        // check
        if (btns.length === 0) return false;
        // click fancy
        btns.each(function(){
            // this
            var btn = $(this);
            // bind fancy
            btn.on('click',function(){
                var hotel_id = $(this).data('hotel_id');
                accorBookNow({destination:hotel_id});
            });
        });
    };


    /////////////// DOM READY
    $(document).ready(function() {

        // book now hotel button
        hotel_book_now();

        // booking form
        hotel_bookingform();

    });

})(jQuery);